/**
 * Custom hook that exposes the AlertContext value to any functional component.
 *
 * @module components/common/UseAlert
 * @author Snowfly
 * @version 1.0.0
 */
import { useContext } from 'react';
import AlertContext from './AlertContext';

/**
 * Custom hook for accessing the AlertContext.
 *
 * This hook provides access to the AlertContext, allowing components to retrieve
 * and utilize alert-related state or functionality within the context.
 *
 * @returns {object} The current value of the AlertContext.
 */
const useAlert = () => useContext(AlertContext);

export default useAlert;
